module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_5012.ac1a0690.png";